import React, {FunctionComponent, useEffect, useRef} from 'react'
import CarlineGroup from '../../entities/CarlineGroup'
import CarlineGridGroupCarlines from './CarlineGridGroupCarlines'
import style from './carlineGridGroup.css'
import CarlineGroupPlaceholderImage from '../../assets/media/car-silhouette56.svg'
import CarlineImage from '../carline-image'

export type Props = {
    carlineGroup: CarlineGroup
    activeGroupId: string
    setActiveCarlineGroupId: Function
    backgroundImageType: string
    carlineInRow?: number
}

const CarlineGridGroup: FunctionComponent<Props> = (props) => {
    const {
        carlineGroup,
        activeGroupId,
        setActiveCarlineGroupId,
        backgroundImageType,
        carlineInRow,
    } = props
    const {
        id,
        carlines,
        name,
        media,
    } = carlineGroup

    const carlineGroupRef = useRef<HTMLButtonElement  | null>(null)

    useEffect(() => {
        if (activeGroupId === id && carlineGroupRef.current) {
            carlineGroupRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
    }, [activeGroupId, id])

    if (carlines.length === 0) {
        return null
    }

    const isOpen = activeGroupId === id
    const imgElement = media?.length > 0 ? (
        <CarlineImage
            media={media}
            alt={name}
            className={style.img}
            width={590}
            height={253}
            backgroundColor="ffffff"
            backgroundImageType={backgroundImageType}
        />
    ) : <CarlineGroupPlaceholderImage className={style.imgPlaceholder} />

    const toggleCarlines = (): void => {

        const newActiveGroupId = isOpen ? '' : id

        setActiveCarlineGroupId(newActiveGroupId)
    }

    const carlineListElement = isOpen ? (
        <CarlineGridGroupCarlines
            carlines={carlines}
            carlineGroupName={name}
            closeCarlineList={toggleCarlines}
            backgroundImageType={backgroundImageType}
            carlineInRow={carlineInRow}
        />
    ) : null

    const openedClass = isOpen ? style.buttonOpened : ''

    return (
        <>
            <button
                ref={carlineGroupRef}
                onClick={toggleCarlines}
                className={`${style.button} ${openedClass}`}
                type="button"
                data-testid={`carline-group-toggle-button-${id.replace(/\\/g, '.')}`}
            >
                <div>
                    {imgElement}
                </div>
                <span className={style.title} data-testid="carline-title-carlines-page">{name}</span>
            </button>
            {carlineListElement}
        </>
    )
}

export default CarlineGridGroup
